import React from "react";

import {
  Grid,
  Box,
  Typography,
  IconButton,
  Dialog,
  AppBar,
  Toolbar,
  Slide,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { TransitionProps } from "@mui/material/transitions";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface FullScreenDialogProps {
  open: boolean;
  handleClose: () => void;
  title: string;
  children: React.ReactNode;
}

const FullScreenDialog: React.FC<FullScreenDialogProps> = ({
  open,
  handleClose,
  title,
  children,
}) => {
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }} color="transparent">
        <Toolbar>
          <Typography
            sx={{ ml: 2, flex: 1, textAlign: "center" }}
            variant="h6"
            component="div"
          >
            {title}
          </Typography>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Grid
        container
        rowSpacing={3}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        padding={3}
      >
        <Grid item xs={12}>
          {children}
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default FullScreenDialog;
